<div [id]="getId()" class="modal fade" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <button class="btn-close" data-bs-dismiss="modal" title="Schließen" type="button"></button>
            </div>

            <div class="modal-body">
                @if (!offlineModeService.check) {
                    <div class="row">
                        <div class="col-12">
                            <p>Bitte warten...</p>
                        </div>
                    </div>
                }

                @if (offlineModeService.check && !offlineModeService.check.available) {
                    <div class="row">
                        <div class="col-12">
                            <i class="fas fa-4x fa-folder-download icon-yellow"></i>
                            <i class="fas fa-3x fa-spinner icon-yellow progress-icon fa-spin"></i>
                        </div>
                        <div class="col-12">
                            <p>Offline Version wird vorbereitet...</p>
                            <p>Wir bereiten dein Offline-Buch für den Download vor.<br>
                                Dies kann etwas Zeit in Anschpruch nehmen.</p>
                            <p>Du kannst dieses Fenster schließen.<br>
                                Sobald dein Buch-Download bereit steht,<br>
                                <strong class="light-green">blinkt das Symbol grün.</strong></p>
                        </div>
                    </div>
                }

                @if (offlineModeService.check && offlineModeService.check.available && offlineModeService.check.available) {
                    <div class="row">
                        <div class="col-12">
                            <i class="fas fa-4x fa-folder-download"></i>
                        </div>
                        <div class="col-12">
                            <p>Offline Version herunterladen</p>
                            <p>Die Offline-Version wird als ZIP-Datei <br>
                                heruntergeladen.</p>
                            <p>Anschließend kannst du das ZIP entpacken.<br>
                                Um das Offline-Buch zu öffnen, klicke auf die<br>
                                <strong>START.html</strong> Datei.</p>
                        </div>
                        <div class="col-12">
                            <a [attr.href]="offlineModeService.check.url"
                               class="btn btn-sm download-button">Download starten <i class="far fa-file-download"></i></a>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
